import { IRawStyle } from "@fluentui/react";
import React, { ReactNode } from "react";
import { ButtonRenderProps, ContentSection } from "sprint-common-web";

import { useOrderRequestAssetNotes } from "../hooks/useOrderRequestAssetNotes";
import { useOrderRequestDetails } from "../hooks/useOrderRequestDetails";
import { OrderRequestDashboardItem } from "../OrderRequestDashboardItem";

interface OrderRequestSectionWrapperProps {
    style?: IRawStyle;
    header: string;
    testId: string;
    children: (orderRequest: OrderRequestDashboardItem, additionalProps?: { areNotesLoading?: boolean }) => ReactNode;
    errorFallback?: ReactNode;
    buttons?: ButtonRenderProps[];
}

export const OrderRequestSectionWrapper = ({
    header,
    style,
    testId,
    children,
    buttons
}: OrderRequestSectionWrapperProps): JSX.Element => {
    const { orderRequest, isLoading } = useOrderRequestDetails();
    const { notes, areNotesLoading } = useOrderRequestAssetNotes({ orderRequest });

    if (!orderRequest || isLoading) {
        return <ContentSection header={header} style={style} isLoading testId={testId} />;
    }

    orderRequest.assetNotes = notes ?? [];

    return (
        <ContentSection header={header} style={style} isLoading={isLoading} buttons={buttons} testId={testId}>
            {children(orderRequest, { areNotesLoading })}
        </ContentSection>
    );
};
